export { Alert, AlertType } from './alert';
export { Anagrafica } from './anagrafica';
export { AnagraficaNota } from './anagrafica-nota';
export { BloccoImmobile } from './blocco-immobile';
export { Cap } from './cap';
export { Collaboratore } from './collaboratore';
export { Comune } from './comune';
export { DatoCatastale } from './dato-catastale';
export { DefinizioneServizio } from './definizione-servizio';
export { DocumentiImmobileUploader } from './documenti-immobile-uploader';
export { DocumentiRichiestaMutuoRichiedenteUploader } from './documenti-richiesta-mutuo-richiedente-uploader';
export { DocumentiRichiestaMutuoUploader } from './documenti-richiesta-mutuo-uploader';
export { DocumentoIdentita } from './documento-identita';
export { DocumentoImmobile } from './documento-immobile';
export { DocumentoRichiestaMutuo } from './documento-richiesta-mutuo';
export { EfficienzaEnergetica } from './efficienza-energetica';
export { EmailTemplate } from './email-template';
export { Immobile } from './immobile';
export { ImmobileSearch } from './immobile-search';
export { ImpostazioneEmail } from './impostazione-email';
export { ImpostazioneFtp } from './impostazione-ftp';
export { Messaggio } from './messaggio';
export { ModPass } from './mod-pass';
export { ModificaPasswordReset } from './mod-pass-reset';
export { Orario } from './orario';
export { OrarioPrenotazione } from './orario-prenotazione';
export { PacchettoServizio } from './pacchetto-servizio';
export { Profilo } from './profilo';
export { Provincia } from './provincia';
export { ReportObj } from './report-obj';
export { RichiestaMutuo } from './richiesta-mutuo';
export { RichiestaMutuoCambioStato } from './richiesta-mutuo-cambio-stato';
export { RichiestaMutuoNote } from './richiesta-mutuo-note';
export { RichiestaMutuoRichiedente } from './richiesta-mutuo-richiedente';
export { RichiestaMutuoRichiedenteImpegno } from './richiesta-mutuo-richiedente-impegno';
export { RichiestaMutuoSearch } from './richiesta-mutuo-search';
export { Sconto } from './sconto';
export { Servizio } from './servizio';
export { ServizioAcquistato } from './servizio-acquistato';
export { ServizioSearch } from './servizio-search';
export { StaticUrls } from './static-urls';
export { StatoRichiestaMutuo } from './stato-richiesta-mutuo';
export { TipologiaUtente } from './tipologia-utente';
export { Transazione } from './transazione';
export { Trascodifica } from './trascodifica';
export { User } from './user';
export { AnagraficaAutocomplete } from './anagrafica-autocomplete';
export { AnagraficaPreferenze} from './anagrafica-preferenze';
export { BloccoImmobileSearch } from './blocco-immobile-search';


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/index.ts